import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const SubcompanyDeleteModal = ({ handleClose, handleAccept, isOpened, subcompany, t }) => (
  <Common.Modal show={isOpened} handleClose={handleClose} keyboard={false}>
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLongTitle">
          {t('subcompanies.delete_title')}
        </h5>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        className="modal-body"
        dangerouslySetInnerHTML={{
          __html: t('subcompanies.delete_confirm', subcompany),
        }}
      />
      <div className="modal-footer">
        <Form.Button
          type="button"
          className="btn btn-secondary"
          text={t('actions.cancel')}
          onClick={handleClose}
        />

        <Form.Button
          type="button"
          className="btn btn-warning"
          text={t('actions.confirm')}
          onClick={handleAccept}
        />
      </div>
    </div>
  </Common.Modal>
);

SubcompanyDeleteModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleAccept: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired,
  subcompany: PropTypes.object,
  t: PropTypes.func.isRequired,
};

export default translate()(SubcompanyDeleteModal);



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/SubcompanyDeleteModal.js